import { call, put, takeLatest } from "redux-saga/effects";
import { dotTuyenSinhApi } from "../../../api/category/dotTuyenSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDotTuyenSinhActionIds,
  IDotTuyenSinhActionTypes,
} from "../../action-types/category/IDotTuyenSinhActions";
import { rootActions } from "../../actions/rootActions";

export function* dotTuyenSinhSaga(): any {
  yield takeLatest(eDotTuyenSinhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IDotTuyenSinhActionTypes): any {
  const res: IBaseRespone = yield call(
    dotTuyenSinhApi.SelectByNam,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.dotTuyenSinh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.dotTuyenSinh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
